import { AfterViewInit, ChangeDetectorRef, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Ondemand, OndemandHome } from '../../shared/interfacce.model';

@Component({
  selector: 'app-galleria-video',
  templateUrl: './galleria-video.component.html',
  styleUrls: ['./galleria-video.component.css']
})
export class GalleriaVideoComponent implements AfterViewInit {
  
  constructor(private router: Router, private cdr: ChangeDetectorRef) { }  

  @Input() ondemands_home?: OndemandHome;
  @Input() ondemands: Ondemand[] = [];  

  sliderIndex: number = 0;
  sliderSlides: number = 0;

  ngAfterViewInit(): void {
    this.sliderIndex = this.sliderIndex != 0 ? this.sliderIndex : this.sliderSlides;    
  }

  onOndemand(id: number) {
    this.router.navigate(['/ondemand/' + btoa("id_ondemand=" + id)]);        
  }

  onSlideChange(index: number) {        
    this.sliderIndex = index < 4 ? 4 : (index + 4)
    this.cdr.detectChanges();
  }
  
}